export const state = {
  occupations: [],
  systemOccupation: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/occupations/state.js